<template>
  <Auth :auth="auth">
    <template v-slot:default>
      <el-button v-bind="$attrs" v-on="$listeners">
        <slot></slot>
      </el-button>
    </template>

    <template v-slot:denied>
      <el-button v-bind="$attrs" v-on="$listeners" disabled>
        <slot></slot>
      </el-button>
    </template>
  </Auth>
</template>

<script>
  import Auth from './Auth'
  export default {
    name: 'l-auth-button',
    components: {
      Auth
    },
    props: {
      auth: {
        type: String,
        required: true
      }
    }
  }
</script>